import { useAuth } from "../../contexts/AuthContext";
import { MenuPanel } from "../../components/Menu/MenuPanel";
import { type AppUser } from "../../data/menu";

/**
 * ============================================================================
 * MenuPage (トップメニュー画面)
 * ============================================================================
 * ログイン直後に表示されるメイン画面です。
 * ユーザー情報の「型の不一致」をここで吸収し、MenuPanelに渡します。
 */
const MenuPage = () => {
  // AuthContextからログイン中のユーザー情報を取得
  const { currentUser } = useAuth();

  // ユーザー情報のロードが間に合っていない場合の安全策
  if (!currentUser) return null;

  // AuthContextのユーザー型(id, name等) を、
  // menu.tsが求める AppUser型(Id, UserName等) に変換します。
  const convertedUser: AppUser = {
    // 大文字・小文字どちらで来ても対応できるように変換
    Id: (currentUser as any).Id || (currentUser as any).id || "unknown",

    // UserName も同様に name プロパティ等から拾う
    UserName:
      (currentUser as any).UserName || (currentUser as any).name || "ユーザー",

    // ロールがない場合は安全のため 'buyer' に倒す
    role: (currentUser as any).role || "Buyer",

    // サブロールがあれば渡す
    // subRole: (currentUser as any).subRole
  };

  return (
    <div className="max-w-7xl mx-auto pb-12 w-full">
      {/* --- ページタイトルエリア --- */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
          トップメニュー
        </h2>
        <p className="text-slate-500 text-sm mt-1">業務を選択してください</p>
      </div>

      {/* --- メニューパネルの配置 --- 
          変換済みの convertedUser を渡すことで、型エラーを解消します
      */}
      <MenuPanel currentUser={convertedUser} />
    </div>
  );
};

export default MenuPage;
